import right from "../../assets/right.svg";
import aboutImage from "../../assets/about-img.png";
import Iphone from "./Iphone";
import "./style.css";

const About = () => {
	const data = [
		{
			label: "Smart Valet Request",
			description:
				"Users can request a valet through the app before arrival. The system assigns the nearest available valet to ensure minimal waiting time",
		},
		{
			label: "Real-Time Vehicle Tracking",
			description:
				"Track your car’s status and location in real-time using GPS integration — know exactly where your vehicle is parked or when it’s en route back to you",
		},
		{
			label: "Digital Ticket System",
			description:
				"No more paper tickets — users receive a digital valet token or QR code for secure and contactless vehicle retrieval.",
		},
		{
			label: "Automated Payment & Receipts",
			description:
				"Integrated online payment options (credit/debit, wallet, or UPI) with instant e-receipts.",
		},
		// {
		// 	label: "Smart Parking Space Management",
		// 	description:
		// 		"The system optimizes available parking slots and guides valet staff to the most efficient parking locations.",
		// },
		// {
		// 	label: "User Notifications",
		// 	description:
		// 		"Get instant alerts when your car is parked, ready for pickup, or moved.",
		// },
		// {
		// 	label: "Security & Verification",
		// 	description:
		// 		"Driver identity verification and digital records ensure safety and prevent vehicle misuse.",
		// },
	];

	return (
		<div className="about" id="About">
			<div className="container">
				<p className="title">About Our App</p>
				<p className="description">
					Book a valet before arriving at your destination. Real-time valet
					availability and estimated arrival time.
				</p>
				<div className="about-data">
					<div className="row">
						<div className="col-md-6 text-center">
							<Iphone aboutImage={aboutImage} />
						</div>
						<div className="col-md-6">
							<div className="about-description">
								{data?.map((res, index) => {
									return (
										<div key={index} className="about-description-card">
											<img src={right} alt="right" />
											<div>
												<p className="title">{res?.label}</p>
												<p className="description">{res?.description}</p>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default About;
